/**
 * Usonian CSS > Generic > Shared
 */

import { css } from 'styled-components';
import { globals } from 'shared/styles/settings';

export default css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  dl,
  dd,
  ol,
  ul,
  fieldset,
  figure,
  table,
  caption,
  hr {
    margin-bottom: ${globals.baseSpace};
  }
`;
